import React, { useEffect, useContext, useState, useRef } from 'react';
import { Typography, Grid, Button, Box } from '@mui/material';

import {
  PointOfSale as PointOfSaleIcon,
  Money as MoneyIcon,
  Receipt as ReceiptIcon,
  AddCard,
  AccountCircle,
  QrCodeScanner as QrCodeScannerIcon,
  Coffee as CoffeeIcon,
  LocalPrintshop as LocalPrintshopIcon,
  Print as PrintIcon,
  Close as CloseIcon,
} from '@mui/icons-material';

import { AppContext } from '../../../context/Context';
import toast, { Toaster } from 'react-hot-toast';
import { useTranslation } from 'react-i18next';

import { SocketContext } from '../../../context/SocketContext';
import { confirmAlert } from 'react-confirm-alert';

function VendorItemOptions({ vendor }) {
  const {
    updateInfoAutoOpenAfterCloseZeroTicket,
    WGBingoID,
    OKBingoID,
    updateIsLoadingScreen,
    updateLastDataBingoTicket,
    updateShowModalBlockedToBuyDataBingo,
    isDataBingoBlockedInKiosk,
    updateShowModalSellPapir,
    updateShowModalSellPapirXtipp,
    updateShowModalSellPapirKingo,
    updateShowModalSellKiosk,
    isSystemLockEnabled,
    userLogin,
    updateCurrentUser,
    updateUserLogin,
    isBlockProviderOK,
    isBlockProviderWG,
    isBlockProviderEBS,
    updateIsSellerOpen,
    updateVendorInfo,
    updateSellType,
    isFullUser,
    parentInfo,
    updateShowSpillerkonto,
    hall,
    printer,
    currentUser,
    updateUserInfo,
    isLimitSurpassed,
    updateShowIsLimitSurpassed,
    isVerificationNeeded,
    updateShowModalIsVerificationNeeded,
    isOKBingoEnabled,
    isWGEnabled,
    userInfo,
    updateUserInfoBlocked,
    isWaitingForExternalProviderInfo,
    disableSellForUser,
    isPapirEnabled,
    isPapirKingoEnabled,
    isPapirXtippEnabled,
    session,
  } = useContext(AppContext);

  const { socket } = useContext(SocketContext);

  const { t } = useTranslation();

  const WGBingoIDRef = useRef(WGBingoID);
  useEffect(() => {
    WGBingoIDRef.current = WGBingoID;
  }, [WGBingoID]);

  const OKBingoIDRef = useRef(OKBingoID);
  useEffect(() => {
    OKBingoIDRef.current = OKBingoID;
  }, [OKBingoID]);

  const isDataBingoBlockedInKioskRef = useRef(isDataBingoBlockedInKiosk);
  useEffect(() => {
    isDataBingoBlockedInKioskRef.current = isDataBingoBlockedInKiosk;
  }, [isDataBingoBlockedInKiosk]);

  const isPapirEnabledRef = useRef(isPapirEnabled);
  useEffect(() => {
    isPapirEnabledRef.current = isPapirEnabled;
  }, [isPapirEnabled]);

  const isPapirKingoEnabledRef = useRef(isPapirKingoEnabled);
  useEffect(() => {
    isPapirKingoEnabledRef.current = isPapirKingoEnabled;
  }, [isPapirKingoEnabled]);

  const isPapirXtippEnabledRef = useRef(isPapirXtippEnabled);
  useEffect(() => {
    isPapirXtippEnabledRef.current = isPapirXtippEnabled;
  }, [isPapirXtippEnabled]);

  const disableSellForUserRef = useRef(disableSellForUser);
  useEffect(() => {
    disableSellForUserRef.current = disableSellForUser;
  }, [disableSellForUser]);

  const userInfoRef = useRef(userInfo);
  useEffect(() => {
    userInfoRef.current = userInfo;
  }, [userInfo]);

  const parentInfoRef = useRef(parentInfo);
  useEffect(() => {
    parentInfoRef.current = parentInfo;
  }, [parentInfo]);

  const hallRef = useRef(hall);
  useEffect(() => {
    hallRef.current = hall;
  }, [hall]);

  const isSystemLockEnabledRef = useRef(isSystemLockEnabled);
  useEffect(() => {
    isSystemLockEnabledRef.current = isSystemLockEnabled;
  }, [isSystemLockEnabled]);

  useEffect(() => {
    const handleCheckDataBingoTickets = (data) => {
      console.log('Received checkDataBingoTickets response:', data);
      if (!data) {
        updateIsLoadingScreen(false);
        updateShowModalBlockedToBuyDataBingo(false);
        return;
      }

      if (data.isLocked && !data.lastTicketDataBingo) {
        updateIsLoadingScreen(false);
        updateUserInfoBlocked(data.tickets);
        updateShowModalBlockedToBuyDataBingo(true);
        return;
      }

      if (data.isLocked && data.lastTicketDataBingo) {
        let provider = '';

        const v = String(data.lastTicketDataBingo ?? '');
        const len = v.length;
        if (len <= 4) provider = 'CH';
        if (len === 7) provider = 'OK D.';
        if (len > 7) provider = 'WG';

        if (provider === 'OK D.') {
          let dataToSearch = {};
          dataToSearch.okID = data.lastTicketDataBingo;
          dataToSearch.action = 'searchTicketOKD';
          dataToSearch.session = session;
          dataToSearch.searchByID = true;
          dataToSearch.bingoName = hallRef.current;
          dataToSearch.vendorInfo = data.vendorInfo;
          dataToSearch.sellType = data.sellType;
          socket.emit('searchTicketOKD', dataToSearch);
        }

        if (provider === 'WG') {
          let dataToSearch = {};
          dataToSearch.wgID = data.lastTicketDataBingo;
          dataToSearch.action = 'searchTicketWG';
          dataToSearch.session = session;
          dataToSearch.searchByID = true;
          dataToSearch.bingoName = hallRef.current;
          dataToSearch.bingoID = WGBingoIDRef.current;
          dataToSearch.vendorInfo = data.vendorInfo;
          dataToSearch.sellType = data.sellType;
          socket.emit('searchTicketWG', dataToSearch);
        }

        /*
          updateLastDataBingoTicket(data.lastTicketDataBingo);
          updateShowModalBlockedToBuyDataBingo(true);
          */
        return;
      }

      console.log('User is not locked, proceeding with sell kiosk flow');

      updateIsLoadingScreen(false);
      updateVendorInfo(data.vendorInfo);
      updateSellType(data.sellType);
      updateShowModalSellKiosk(true);
    };

    const handleCheckMainGameTickets = (data) => {
      if (!data) {
        return;
      }
      /*
      if (data.tickets.length > 0) {
        updateUserInfoBlocked(data.tickets);
        updateShowModalSellBlocked(true);
        return;
      }
        */
      updateIsSellerOpen(true);
      updateVendorInfo(data.vendorInfo);
      updateSellType(data.sellType);
    };

    const handleSearchTicketWG = (data) => {
      console.log('Received searchTicketWG response:', data);

      let dataLastTicketWG = {};
      dataLastTicketWG.ticketID = data.ticket.wgID;
      dataLastTicketWG.provider = 'WG';
      dataLastTicketWG.balance = data.ticket.currentBalance;
      dataLastTicketWG.vendorInfo = data.vendorInfo;
      dataLastTicketWG.sellType = data.sellType;
      dataLastTicketWG.isInUse = data.ticket.isInUse;

      updateLastDataBingoTicket(dataLastTicketWG);
      updateShowModalBlockedToBuyDataBingo(true);
      updateIsLoadingScreen(false);
    };

    const handleSearchTicketOKD = (data) => {
      console.log('Received searchTicketOKD response:', data);

      let dataLastTicketOKD = {};
      dataLastTicketOKD.ticketID = data.okID;
      dataLastTicketOKD.provider = 'OK D.';
      dataLastTicketOKD.vendorInfo = data.vendorInfo;
      dataLastTicketOKD.sellType = data.sellType;

      updateLastDataBingoTicket(dataLastTicketOKD);
      updateShowModalBlockedToBuyDataBingo(true);
      updateIsLoadingScreen(false);
    };

    socket.on('checkDataBingoTickets', handleCheckDataBingoTickets);
    socket.on('checkMainGameTickets', handleCheckMainGameTickets);

    socket.on('searchTicketWG', handleSearchTicketWG);
    socket.on('searchTicketOKD', handleSearchTicketOKD);

    return () => {
      socket.off('checkDataBingoTickets', handleCheckDataBingoTickets);
      socket.off('checkMainGameTickets', handleCheckMainGameTickets);

      socket.off('searchTicketWG', handleSearchTicketWG);
      socket.off('searchTicketOKD', handleSearchTicketOKD);
    };
  }, [socket]);

  const checkColor = (type, originalColor) => {
    if (
      userInfoRef.current &&
      userInfoRef.current.username === 'Gjest' &&
      (type === 3 || type === 4 || type === 5 || type === 6)
    ) {
      return 'grey';
    }
    if (type === 1 && !isPapirEnabledRef.current) {
      return 'grey';
    }
    if (type === 101 && !isPapirKingoEnabledRef.current) {
      return 'grey';
    }
    if (type === 102 && !isPapirXtippEnabledRef.current) {
      return 'grey';
    }
    if (
      (type === 1 ||
        type === 101 ||
        type === 102 ||
        type === 3 ||
        type === 4 ||
        type === 6 ||
        type === 24 ||
        type === 25 ||
        type === 26 ||
        type === 10) &&
      disableSellForUserRef.current
    ) {
      return 'grey';
    }
    if (
      type === 1 ||
      type === 101 ||
      type === 102 ||
      type === 9 ||
      type === 10 ||
      type === 12 ||
      type === 13 ||
      type === 14
    ) {
      return originalColor;
    }
    if (!userLogin || (userLogin && currentUser === 'Gjest')) {
      return 'grey';
    }

    //Full member as parent, loggin with children tickets

    if (
      type === 11 &&
      !isFullUser &&
      (!parentInfo ||
        (parentInfo &&
          (parentInfo.username.startsWith('anon-') ||
            parentInfo.username.startsWith('hybrid-'))))
    ) {
      return 'grey';
    }

    if (!isFullUser && !parentInfo && (type === 2 || type === 11)) {
      return 'grey';
    }
    return originalColor;
  };

  const checkOpacity = (type, originalColor) => {
    if (
      userInfoRef.current &&
      userInfoRef.current.username === 'Gjest' &&
      (type === 3 || type === 4 || type === 5 || type === 6)
    ) {
      return '0.25';
    }

    if (type === 1 && !isPapirEnabledRef.current) {
      return '0.25';
    }
    if (type === 101 && !isPapirKingoEnabledRef.current) {
      return '0.25';
    }

    if (
      (type === 1 ||
        type === 3 ||
        type === 4 ||
        type === 6 ||
        type === 24 ||
        type === 25 ||
        type === 26 ||
        type === 10) &&
      disableSellForUserRef.current
    ) {
      return '0.25';
    }
    if (
      type === 1 ||
      type === 101 ||
      type === 102 ||
      type === 9 ||
      type === 10 ||
      type === 12 ||
      type === 13 ||
      type === 14
    ) {
      return '1';
    }
    if (!userLogin || (userLogin && currentUser === 'Gjest')) {
      return '0.25';
    }

    //Full member as parent, loggin with children tickets
    if (
      type === 11 &&
      !isFullUser &&
      (!parentInfo ||
        (parentInfo &&
          (parentInfo.username.startsWith('anon-') ||
            parentInfo.username.startsWith('hybrid-'))))
    ) {
      return '0.25';
    }

    if (
      !isFullUser &&
      !parentInfo &&
      (type === 1 || type === 2 || type === 11)
    ) {
      return '0.25';
    }
    return '1';
  };

  const checkLogin = (type) => {
    if (
      type === 1 ||
      type === 101 ||
      type === 102 ||
      type === 9 ||
      type === 10 ||
      type === 12 ||
      type === 13 ||
      type === 14
    ) {
      return false;
    }
    if (!userLogin || (userLogin && currentUser === 'Gjest')) {
      //CHANGE THIS FOR MODAL
      toast.error(t('error.userNotLogin'));
      return false;
    }

    if (
      type === 11 &&
      !isFullUser &&
      (!parentInfo || (parentInfo && parentInfo.username.startsWith('anon-')))
    ) {
      toast.error(t('error.userNotMember'));
      return false;
    }

    if (!isFullUser && !parentInfo && (type === 1 || type === 2)) {
      toast.error(t('error.userNotMember'));
      return false;
    }
    return true;
  };

  const modalConfirm = (providerCode, vendor, option) => {
    var confirmMessage = t('sales.confirmOK');

    switch (providerCode) {
      case 'OK':
        confirmMessage = t('sales.confirmOK');
        break;
      case 'WG':
        confirmMessage = t('sales.confirmWG');
        break;
      case 'NT':
        confirmMessage = t('sales.confirmNT');
        break;
      default:
        break;
    }

    confirmAlert({
      title: confirmMessage,
      message: '',
      buttons: [
        {
          label: t('sales.confirm'),
          onClick: () => {
            updateIsSellerOpen(true);
            updateVendorInfo(vendor);
            updateSellType(option.type);
          },
          className: 'btn-custom-yes',
        },

        {
          label: t('sales.cancel'),
          onClick: () => {},
          className: 'btn-custom-no',
        },
      ],
    });
  };

  async function startsWithPrefix(str) {
    return str.startsWith('anon-') || str.startsWith('hybrid-');
  }

  const handlePrint = () => {
    socket.emit('printLastShoppingCart', { printer: printer, bingoName: hall });
  };

  const handleClickButton = async (option, providerCode) => {
    updateInfoAutoOpenAfterCloseZeroTicket({
      sellType: option.type,
      vendor: vendor,
    });
    if (
      userInfoRef.current &&
      userInfoRef.current.username === 'Gjest' &&
      (option.type === 3 ||
        option.type === 4 ||
        option.type === 5 ||
        option.type === 6)
    ) {
      return;
    }

    if (option.type === 1 && !isPapirEnabledRef.current) {
      return;
    }
    if (option.type === 101 && !isPapirKingoEnabledRef.current) {
      return;
    }
    if (option.type === 102 && !isPapirXtippEnabledRef.current) {
      return;
    }
    if (
      (option.type === 1 ||
        option.type === 101 ||
        option.type === 3 ||
        option.type === 4 ||
        option.type === 6 ||
        option.type === 24 ||
        option.type === 25 ||
        option.type === 26 ||
        option.type === 10) &&
      disableSellForUserRef.current
    ) {
      return;
    }

    if (isVerificationNeeded && currentUser && currentUser !== 'Gjest') {
      updateShowModalIsVerificationNeeded(true);
      return;
    }

    if (
      (option.type === 4 || option.type === 5 || option.type === 6) &&
      isWaitingForExternalProviderInfo
    ) {
      toast.error(t('error.waitingExternalProvider'));
      return;
    }

    if (
      isLimitSurpassed &&
      currentUser &&
      currentUser !== 'Gjest' &&
      (option.type === 3 ||
        option.type === 4 ||
        option.type === 6 ||
        option.type === 24 ||
        option.type === 26)
    ) {
      updateShowIsLimitSurpassed(true);
      return;
    }

    if (option.type === 4 && isDataBingoBlockedInKioskRef.current) {
      //Show modal only 1 ticket

      updateShowModalBlockedToBuyDataBingo(true);
      return;
    }

    var isParentAnon = true;

    if (parentInfo !== false) {
      isParentAnon = await startsWithPrefix(parentInfo.username);
    }

    //Papir
    if (option.type === 1 && isPapirEnabledRef.current) {
      updateShowModalSellPapir(true);
      updateVendorInfo(vendor);
      updateSellType(option.type);

      if (!currentUser) {
        updateCurrentUser('Gjest');
        updateUserLogin(true);
        updateUserInfo({ username: 'Gjest', firstname: 'Gjest' });
      }
    }

    if (option.type === 101 && isPapirKingoEnabledRef.current) {
      updateShowModalSellPapirKingo(true);
      updateVendorInfo(vendor);
      updateSellType(option.type);

      if (!currentUser) {
        updateCurrentUser('Gjest');
        updateUserLogin(true);
        updateUserInfo({ username: 'Gjest', firstname: 'Gjest' });
      }
    }

    if (option.type === 102 && isPapirXtippEnabledRef.current) {
      updateShowModalSellPapirXtipp(true);
      updateVendorInfo(vendor);
      updateSellType(option.type);

      if (!currentUser) {
        updateCurrentUser('Gjest');
        updateUserLogin(true);
        updateUserInfo({ username: 'Gjest', firstname: 'Gjest' });
      }
    }

    if (
      option.type === 11 &&
      (isFullUser || (parentInfo !== false && !isParentAnon))
    ) {
      updateShowSpillerkonto(true);
      return;
    }

    if (!checkLogin(option.type)) {
      return;
    }

    /* SELL TICKET CH,WG,OK */
    if (
      option.type === 5 ||
      option.type === 24 ||
      option.type === 25 ||
      (!isSystemLockEnabledRef.current && option.type === 4)
    ) {
      if (
        ((isBlockProviderOK && providerCode === 'OK') ||
          (isBlockProviderWG && providerCode === 'WG') ||
          (isBlockProviderEBS && providerCode === 'EBS')) &&
        (option.type === 4 || option.type === 24)
      ) {
        toast.error(t('error.blockProvider'));
        return;
      }

      if (
        (providerCode === 'OK' && !isOKBingoEnabled && option.type === 5) ||
        option.type === 13 ||
        option.type === 14
      ) {
        modalConfirm(providerCode, vendor, option);
        return;
      }

      if (
        (providerCode === 'WG' && !isWGEnabled && option.type === 5) ||
        option.type === 13 ||
        option.type === 14
      ) {
        modalConfirm(providerCode, vendor, option);
        return;
      }

      updateVendorInfo(vendor);
      updateSellType(option.type);
      updateShowModalSellKiosk(true);
    }
    /*DEPOSIT,WITHDRAW,BANKTRANSFER CH*/
    if (
      option.type === 2 ||
      option.type === 6 ||
      option.type === 26 ||
      (!isSystemLockEnabledRef.current && option.type === 3)
    ) {
      if (!userLogin) {
        toast.error(t('sales.scanMessage'));
        return;
      }

      if (
        (providerCode === 'OK' || providerCode === 'WG') &&
        option.type === 5
      ) {
        modalConfirm(providerCode, vendor, option);
        return;
      }

      console.log(vendor, option.type);

      updateVendorInfo(vendor);
      updateSellType(option.type);
      updateShowModalSellKiosk(true);
    }
    if (option.type === 9) {
      /* */
    }

    //Check databingoBlock
    if (option.type === 4 && isSystemLockEnabledRef.current) {
      updateUserInfoBlocked(false);
      updateIsLoadingScreen(true);
      socket.emit('checkDataBingoTickets', {
        bingoName: hallRef.current,
        userID: parentInfoRef.current
          ? parentInfoRef.current.id
          : userInfoRef.current.id,
        vendorInfo: vendor,
        sellType: option.type,
      });
    }

    if (option.type === 3) {
      updateVendorInfo(vendor);
      updateSellType(option.type);
      updateShowModalSellKiosk(true);
    }
  };

  return (
    <>
      {/* Toaster outside the flex box so it doesn't affect centering */}
      <Toaster
        position="top-center"
        reverseOrder={false}
        containerStyle={{ zIndex: 99999999 }}
      />

      <Box
        sx={{
          mt: 0,
          flex: 1,
          display: 'flex',
          alignItems: 'flex-start',
          justifyContent: 'center',
        }}
      >
        <Grid
          container
          justifyContent="flex-start"
          alignContent="flex-start"
          flexDirection="row"
          sx={{
            width: '100%',
            m: 0,
          }}
        >
          {vendor.options.map((option, index) => {
            let providerCode = '';
            if (vendor.name === 'WinGames') {
              providerCode = 'WG';
            } else if (vendor.name === 'OK Databingo') {
              providerCode = 'OK';
            } else if (vendor.name === 'Norsk Tipping') {
              providerCode = 'NT';
            } else if (vendor.name === 'EBS') {
              providerCode = 'EBS';
            }

            if (option.type === 8) return null;
            if (option.type === 9 || option.type === 10 || option.type === 12)
              return null;
            if (option.type === 5) return null;

            return (
              <Grid
                item
                key={index}
                xs={6}
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  p: 1.0,
                }}
              >
                <Button
                  variant="contained"
                  component="label"
                  sx={{
                    height: 178,
                    width: 218,
                    m: 0,
                    p: 0,
                    borderRadius: '15px',
                    backgroundColor: checkColor(option.type, option.color),
                    opacity: checkOpacity(option.type, option.color),
                    color: 'white',
                    fontWeight: 'bold',
                    textTransform: 'uppercase',
                    fontSize: 20,
                    textAlign: 'center',
                  }}
                  onClick={async () => {
                    await handleClickButton(option, providerCode);
                  }}
                >
                  <Box
                    sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center', // vertical centering of icon+text
                      height: '100%',
                      width: '100%',
                      textAlign: 'center',
                    }}
                  >
                    {option.type === 1 && <PrintIcon sx={{ fontSize: 38 }} />}
                    {option.type === 2 && <MoneyIcon sx={{ fontSize: 38 }} />}
                    {option.type === 3 && <ReceiptIcon sx={{ fontSize: 38 }} />}
                    {(option.type === 4 ||
                      option.type === 24 ||
                      option.type === 13) && (
                      <ReceiptIcon sx={{ fontSize: 38 }} />
                    )}
                    {(option.type === 5 ||
                      option.type === 25 ||
                      option.type === 14) && (
                      <MoneyIcon sx={{ fontSize: 38 }} />
                    )}
                    {(option.type === 6 || option.type === 26) && (
                      <ReceiptIcon sx={{ fontSize: 38 }} />
                    )}
                    {option.type === 7 && <ReceiptIcon sx={{ fontSize: 38 }} />}
                    {option.type === 8 && (
                      <QrCodeScannerIcon sx={{ fontSize: 38 }} />
                    )}
                    {option.type === 9 && <CoffeeIcon sx={{ fontSize: 38 }} />}
                    {option.type === 10 && <AddCard sx={{ fontSize: 38 }} />}
                    {option.type === 11 && (
                      <AccountCircle sx={{ fontSize: 38 }} />
                    )}
                    {option.type === 12 && (
                      <LocalPrintshopIcon sx={{ fontSize: 38 }} />
                    )}
                    {option.type === 101 && <PrintIcon sx={{ fontSize: 38 }} />}
                    {option.type === 102 && <CloseIcon sx={{ fontSize: 38 }} />}

                    <Typography
                      variant="subtitle1"
                      component="span"
                      sx={{
                        mt: 1,
                        color: 'white',
                        fontWeight: 'bold',
                        textTransform: 'uppercase',
                        fontSize: '20px',
                      }}
                    >
                      {option.option}
                    </Typography>
                  </Box>
                </Button>
              </Grid>
            );
          })}
        </Grid>
      </Box>
    </>
  );
}

export default VendorItemOptions;
